import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const Books: React.FC<Props> = () => {
  return (
    <SVGIcon viewBox="0 0 24 24" width="24" height="22" fill="none">
      <path
        d="M4.5 0C2.02656 0 0 2.02656 0 4.5V5.5H0.203125C0.645602 7.36809 2.1973 8.77164 4.15625 8.92969C3.47068 9.78581 3 10.8247 3 12V13H3.20312C3.3615 13.7456 3.65757 14.416 4.10938 15H3.5C1.57881 15 0 16.5788 0 18.5V19.5H0.205078C0.645351 20.9302 1.93269 22 3.5 22H22V20H20.5312C20.3134 19.6738 20 19.1396 20 18.5C20 17.8604 20.3134 17.3262 20.5312 17H21H24V15H22.6465C22.3879 14.3883 22 13.2859 22 12C22 10.7141 22.3879 9.61168 22.6465 9H24V7H22H20.6113C20.3613 6.47357 20 5.55433 20 4.5C20 3.44567 20.3613 2.52643 20.6113 2H22V0H4.5ZM4.5 2H18.4453C18.2076 2.68296 18 3.53981 18 4.5C18 5.46019 18.2076 6.31704 18.4453 7H8H4.5C3.10744 7 2 5.89256 2 4.5C2 3.10744 3.10744 2 4.5 2ZM8 9H11V14L13 12L15 14V9H20.5059C20.2451 9.79169 20 10.8324 20 12C20 13.1676 20.2451 14.2083 20.5059 15H8C6.33152 15 5 13.6685 5 12C5 10.3315 6.33152 9 8 9ZM3.5 17H8H18.2773C18.1187 17.4388 18 17.9395 18 18.5C18 19.0605 18.1187 19.5612 18.2773 20H3.5C2.65919 20 2 19.3408 2 18.5C2 17.6592 2.65919 17 3.5 17Z"
        fill="black"
      />
    </SVGIcon>
  );
};

export default Books;
